export const limit = 8;
